import { setAlphaOnHexColor } from './setAlphaOnHexColor.js';
import { setAlphaOnRgbColor } from './setAlphaOnRgbColor.js';

const setAlphaOnColor = (color, alpha) => {
  if (color === "transparent") {
    return color;
  }
  if (color.match(/^rgba?\(/) !== null) {
    return setAlphaOnRgbColor(color, alpha);
  }
  return setAlphaOnHexColor(color, alpha);
};

export { setAlphaOnColor };
//# sourceMappingURL=setAlphaOnColor.js.map
